/**
 * Profile form dropdown options and related constants
 */

// Profile For Options
export const PROFILE_FOR_OPTIONS = [
  { value: 'Self', label: 'Self' },
  { value: 'Son', label: 'Son' },
  { value: 'Daughter', label: 'Daughter' },
  { value: 'Brother', label: 'Brother' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Relative', label: 'Relative' },
  { value: 'Friend', label: 'Friend' },
];

// Gender Options
export const GENDER_OPTIONS = [
  { value: '', label: 'Select Gender' },
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' },
];

// Date of Birth Type Options
export const DOB_TYPE_OPTIONS = [
  { value: 'Exact', label: 'Exact' },
  { value: 'Approximate', label: 'Approximate' },
];

// Height Options - values are in cm (numbers) for easy validation, labels show feet/inches
export const HEIGHT_OPTIONS = [
  { value: '', label: 'Select Height' },
  { value: 'Any', label: 'Any' },
  { value: 122, label: '4\'0" (122 cm)' },
  { value: 124, label: '4\'1" (124 cm)' },
  { value: 127, label: '4\'2" (127 cm)' },
  { value: 130, label: '4\'3" (130 cm)' },
  { value: 132, label: '4\'4" (132 cm)' },
  { value: 135, label: '4\'5" (135 cm)' },
  { value: 137, label: '4\'6" (137 cm)' },
  { value: 140, label: '4\'7" (140 cm)' },
  { value: 142, label: '4\'8" (142 cm)' },
  { value: 145, label: '4\'9" (145 cm)' },
  { value: 147, label: '4\'10" (147 cm)' },
  { value: 150, label: '4\'11" (150 cm)' },
  { value: 152, label: '5\'0" (152 cm)' },
  { value: 155, label: '5\'1" (155 cm)' },
  { value: 157, label: '5\'2" (157 cm)' },
  { value: 160, label: '5\'3" (160 cm)' },
  { value: 163, label: '5\'4" (163 cm)' },
  { value: 165, label: '5\'5" (165 cm)' },
  { value: 168, label: '5\'6" (168 cm)' },
  { value: 170, label: '5\'7" (170 cm)' },
  { value: 173, label: '5\'8" (173 cm)' },
  { value: 175, label: '5\'9" (175 cm)' },
  { value: 178, label: '5\'10" (178 cm)' },
  { value: 180, label: '5\'11" (180 cm)' },
  { value: 183, label: '6\'0" (183 cm)' },
  { value: 185, label: '6\'1" (185 cm)' },
  { value: 188, label: '6\'2" (188 cm)' },
  { value: 191, label: '6\'3" (191 cm)' },
  { value: 193, label: '6\'4" (193 cm)' },
  { value: 196, label: '6\'5" (196 cm)' },
  { value: 198, label: '6\'6" (198 cm)' },
  { value: 201, label: '6\'7" (201 cm)' },
  { value: 203, label: '6\'8" (203 cm)' },
  { value: 206, label: '6\'9" (206 cm)' },
  { value: 208, label: '6\'10" (208 cm)' },
  { value: 211, label: '6\'11" (211 cm)' },
  { value: 213, label: '7\'0" (213 cm)' },
];

// Religion Options
export const RELIGION_OPTIONS = [
  { value: '', label: 'Select Religion' },
  { value: 'Any', label: 'Any' },
  { value: 'Hindu', label: 'Hindu' },
  { value: 'Muslim', label: 'Muslim' },
  { value: 'Christian', label: 'Christian' },
  { value: 'Sikh', label: 'Sikh' },
  { value: 'Buddhist', label: 'Buddhist' },
  { value: 'Jain', label: 'Jain' },
  { value: 'Parsi', label: 'Parsi' },
  { value: 'Jewish', label: 'Jewish' },
  { value: 'Bahai', label: 'Bahai' },
  { value: 'Other', label: 'Other' },
];

// Marital Status Options
export const MARITAL_STATUS_OPTIONS = [
  { value: '', label: 'Select Marital Status' },
  { value: 'Any', label: 'Any' },
  { value: 'Never Married', label: 'Never Married' },
  { value: 'Divorced', label: 'Divorced' },
  { value: 'Widowed', label: 'Widowed' },
  { value: 'Separated', label: 'Separated' },
];

// Food Habits Options
export const FOOD_HABITS_OPTIONS = [
  { value: '', label: 'Select Food Habit' },
  { value: 'Any', label: 'Any' },
  { value: 'Vegetarian', label: 'Vegetarian' },
  { value: 'Non-Vegetarian', label: 'Non-Vegetarian' },
  { value: 'Eggetarian', label: 'Eggetarian' },
  { value: 'Jain', label: 'Jain' },
  { value: 'Vegan', label: 'Vegan' },
];

// Family Type Options
export const FAMILY_TYPE_OPTIONS = [
  { value: '', label: 'Select Family Type' },
  { value: 'Nuclear Family', label: 'Nuclear Family' },
  { value: 'Joint Family', label: 'Joint Family' },
];

// Family Status Options
export const FAMILY_STATUS_OPTIONS = [
  { value: '', label: 'Select Family Status' },
  { value: 'Lower Middle Class', label: 'Lower Middle Class' },
  { value: 'Middle Class', label: 'Middle Class' },
  { value: 'Upper Middle Class', label: 'Upper Middle Class' },
  { value: 'Rich', label: 'Rich' },
];

// Family Values Options
export const FAMILY_VALUES_OPTIONS = [
  { value: '', label: 'Select Family Values' },
  { value: 'Traditional', label: 'Traditional' },
  { value: 'Moderate', label: 'Moderate' },
  { value: 'Liberal', label: 'Liberal' },
];

// Survival Status Options
export const SURVIVAL_STATUS_OPTIONS = [
  { value: '', label: 'Select Status' },
  { value: 'Alive', label: 'Alive' },
  { value: 'Passed Away', label: 'Passed Away' },
];

// Time of Birth Options (24-hour format)
export const TIME_OPTIONS = [
  { value: '', label: 'Select Time' },
  { value: '00:00', label: '00:00 (12:00 AM)' },
  { value: '00:30', label: '00:30 (12:30 AM)' },
  { value: '01:00', label: '01:00 (1:00 AM)' },
  { value: '01:30', label: '01:30 (1:30 AM)' },
  { value: '02:00', label: '02:00 (2:00 AM)' },
  { value: '02:30', label: '02:30 (2:30 AM)' },
  { value: '03:00', label: '03:00 (3:00 AM)' },
  { value: '03:30', label: '03:30 (3:30 AM)' },
  { value: '04:00', label: '04:00 (4:00 AM)' },
  { value: '04:30', label: '04:30 (4:30 AM)' },
  { value: '05:00', label: '05:00 (5:00 AM)' },
  { value: '05:30', label: '05:30 (5:30 AM)' },
  { value: '06:00', label: '06:00 (6:00 AM)' },
  { value: '06:30', label: '06:30 (6:30 AM)' },
  { value: '07:00', label: '07:00 (7:00 AM)' },
  { value: '07:30', label: '07:30 (7:30 AM)' },
  { value: '08:00', label: '08:00 (8:00 AM)' },
  { value: '08:30', label: '08:30 (8:30 AM)' },
  { value: '09:00', label: '09:00 (9:00 AM)' },
  { value: '09:30', label: '09:30 (9:30 AM)' },
  { value: '10:00', label: '10:00 (10:00 AM)' },
  { value: '10:30', label: '10:30 (10:30 AM)' },
  { value: '11:00', label: '11:00 (11:00 AM)' },
  { value: '11:30', label: '11:30 (11:30 AM)' },
  { value: '12:00', label: '12:00 (12:00 PM)' },
  { value: '12:30', label: '12:30 (12:30 PM)' },
  { value: '13:00', label: '13:00 (1:00 PM)' },
  { value: '13:30', label: '13:30 (1:30 PM)' },
  { value: '14:00', label: '14:00 (2:00 PM)' },
  { value: '14:30', label: '14:30 (2:30 PM)' },
  { value: '15:00', label: '15:00 (3:00 PM)' },
  { value: '15:30', label: '15:30 (3:30 PM)' },
  { value: '16:00', label: '16:00 (4:00 PM)' },
  { value: '16:30', label: '16:30 (4:30 PM)' },
  { value: '17:00', label: '17:00 (5:00 PM)' },
  { value: '17:30', label: '17:30 (5:30 PM)' },
  { value: '18:00', label: '18:00 (6:00 PM)' },
  { value: '18:30', label: '18:30 (6:30 PM)' },
  { value: '19:00', label: '19:00 (7:00 PM)' },
  { value: '19:30', label: '19:30 (7:30 PM)' },
  { value: '20:00', label: '20:00 (8:00 PM)' },
  { value: '20:30', label: '20:30 (8:30 PM)' },
  { value: '21:00', label: '21:00 (9:00 PM)' },
  { value: '21:30', label: '21:30 (9:30 PM)' },
  { value: '22:00', label: '22:00 (10:00 PM)' },
  { value: '22:30', label: '22:30 (10:30 PM)' },
  { value: '23:00', label: '23:00 (11:00 PM)' },
  { value: '23:30', label: '23:30 (11:30 PM)' },
];

// Birth Star Options (Nakshatram)
export const BIRTH_STAR_OPTIONS = [
  { value: '', label: 'Select Birth Star' },
  { value: 'Any', label: 'Any' },
  { value: 'Ashwini', label: 'Ashwini' },
  { value: 'Bharani', label: 'Bharani' },
  { value: 'Krittika', label: 'Krittika' },
  { value: 'Rohini', label: 'Rohini' },
  { value: 'Mrigashirsha', label: 'Mrigashirsha' },
  { value: 'Ardra', label: 'Ardra' },
  { value: 'Punarvasu', label: 'Punarvasu' },
  { value: 'Pushya', label: 'Pushya' },
  { value: 'Ashlesha', label: 'Ashlesha' },
  { value: 'Magha', label: 'Magha' },
  { value: 'Purva Phalguni', label: 'Purva Phalguni' },
  { value: 'Uttara Phalguni', label: 'Uttara Phalguni' },
  { value: 'Hasta', label: 'Hasta' },
  { value: 'Chitra', label: 'Chitra' },
  { value: 'Swati', label: 'Swati' },
  { value: 'Vishakha', label: 'Vishakha' },
  { value: 'Anuradha', label: 'Anuradha' },
  { value: 'Jyeshtha', label: 'Jyeshtha' },
  { value: 'Mula', label: 'Mula' },
  { value: 'Purva Ashadha', label: 'Purva Ashadha' },
  { value: 'Uttara Ashadha', label: 'Uttara Ashadha' },
  { value: 'Shravana', label: 'Shravana' },
  { value: 'Dhanishta', label: 'Dhanishta' },
  { value: 'Shatabhisha', label: 'Shatabhisha' },
  { value: 'Purva Bhadrapada', label: 'Purva Bhadrapada' },
  { value: 'Uttara Bhadrapada', label: 'Uttara Bhadrapada' },
  { value: 'Revati', label: 'Revati' },

];

// Birth Sign Options (Raasi)
export const BIRTH_SIGN_OPTIONS = [
  { value: '', label: 'Select Birth Sign' },
  { value: 'Any', label: 'Any' },
  { value: 'Aries (Mesha)', label: 'Aries (Mesha)' },
  { value: 'Taurus (Vrishabha)', label: 'Taurus (Vrishabha)' },
  { value: 'Gemini (Mithuna)', label: 'Gemini (Mithuna)' },
  { value: 'Cancer (Karka)', label: 'Cancer (Karka)' },
  { value: 'Leo (Simha)', label: 'Leo (Simha)' },
  { value: 'Virgo (Kanya)', label: 'Virgo (Kanya)' },
  { value: 'Libra (Tula)', label: 'Libra (Tula)' },
  { value: 'Scorpio (Vrischika)', label: 'Scorpio (Vrischika)' },
  { value: 'Sagittarius (Dhanu)', label: 'Sagittarius (Dhanu)' },
  { value: 'Capricorn (Makara)', label: 'Capricorn (Makara)' },
  { value: 'Aquarius (Kumbha)', label: 'Aquarius (Kumbha)' },
  { value: 'Pisces (Meena)', label: 'Pisces (Meena)' },
];

// Skin Complexion Options
export const SKIN_COMPLEXION_OPTIONS = [
  { value: '', label: 'Select Skin Complexion' },
  { value: 'Any', label: 'Any' },
  { value: 'Very Fair', label: 'Very Fair' },
  { value: 'Fair', label: 'Fair' },
  { value: 'Wheatish', label: 'Wheatish' },
  { value: 'Dark', label: 'Dark' },
];

// Alias for backward compatibility
export const COMPLEXION_OPTIONS = SKIN_COMPLEXION_OPTIONS;

// Annual Income Options
export const ANNUAL_INCOME_OPTIONS = [
  { value: '', label: 'Select Annual Income' },
  { value: 'Below 1 Lakh', label: 'Below ₹1 Lakh' },
  { value: '1-2 Lakhs', label: '₹1-2 Lakhs' },
  { value: '2-3 Lakhs', label: '₹2-3 Lakhs' },
  { value: '3-4 Lakhs', label: '₹3-4 Lakhs' },
  { value: '4-5 Lakhs', label: '₹4-5 Lakhs' },
  { value: '5-7 Lakhs', label: '₹5-7 Lakhs' },
  { value: '7-10 Lakhs', label: '₹7-10 Lakhs' },
  { value: '10-15 Lakhs', label: '₹10-15 Lakhs' },
  { value: '15-20 Lakhs', label: '₹15-20 Lakhs' },
  { value: '20-25 Lakhs', label: '₹20-25 Lakhs' },
  { value: '25-30 Lakhs', label: '₹25-30 Lakhs' },
  { value: '30-40 Lakhs', label: '₹30-40 Lakhs' },
  { value: '40-50 Lakhs', label: '₹40-50 Lakhs' },
  { value: '50-75 Lakhs', label: '₹50-75 Lakhs' },
  { value: '75 Lakhs - 1 Crore', label: '₹75 Lakhs - 1 Crore' },
  { value: '1-2 Crores', label: '₹1-2 Crores' },
  { value: '2-5 Crores', label: '₹2-5 Crores' },
  { value: 'Above 5 Crores', label: 'Above ₹5 Crores' },
  { value: 'Prefer not to say', label: 'Prefer not to say' },
];

// Contact Details Options
export const COUNTRY_OPTIONS = [
  { value: 'India', label: 'India' }
];

export const COUNTRY_CODE_OPTIONS = [
  { value: '+91', label: '+91 (India)' }
];

// Mother Tongue Options
export const MOTHER_TONGUE_OPTIONS = [
  { value: 'Tamil', label: 'Tamil' },
  { value: 'Telugu', label: 'Telugu' },
  { value: 'Kannada', label: 'Kannada' },
  { value: 'Malayalam', label: 'Malayalam' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Marathi', label: 'Marathi' },
  { value: 'Gujarati', label: 'Gujarati' },
  { value: 'Bengali', label: 'Bengali' },
  { value: 'Punjabi', label: 'Punjabi' },
  { value: 'Urdu', label: 'Urdu' },
  { value: 'Odia', label: 'Odia' },
  { value: 'Assamese', label: 'Assamese' },
  { value: 'English', label: 'English' },
  { value: 'Other', label: 'Other' },
];

// State Options (Indian states)
export const STATE_OPTIONS = [
  { value: '', label: 'Select State' },
  { value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
  { value: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
  { value: 'Assam', label: 'Assam' },
  { value: 'Bihar', label: 'Bihar' },
  { value: 'Chhattisgarh', label: 'Chhattisgarh' },
  { value: 'Goa', label: 'Goa' },
  { value: 'Gujarat', label: 'Gujarat' },
  { value: 'Haryana', label: 'Haryana' },
  { value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
  { value: 'Jharkhand', label: 'Jharkhand' },
  { value: 'Karnataka', label: 'Karnataka' },
  { value: 'Kerala', label: 'Kerala' },
  { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
  { value: 'Maharashtra', label: 'Maharashtra' },
  { value: 'Manipur', label: 'Manipur' },
  { value: 'Meghalaya', label: 'Meghalaya' },
  { value: 'Mizoram', label: 'Mizoram' },
  { value: 'Nagaland', label: 'Nagaland' },
  { value: 'Odisha', label: 'Odisha' },
  { value: 'Punjab', label: 'Punjab' },
  { value: 'Rajasthan', label: 'Rajasthan' },
  { value: 'Sikkim', label: 'Sikkim' },
  { value: 'Tamil Nadu', label: 'Tamil Nadu' },
  { value: 'Telangana', label: 'Telangana' },
  { value: 'Tripura', label: 'Tripura' },
  { value: 'Uttar Pradesh', label: 'Uttar Pradesh' },
  { value: 'Uttarakhand', label: 'Uttarakhand' },
  { value: 'West Bengal', label: 'West Bengal' },
  { value: 'Delhi', label: 'Delhi' },
  { value: 'Jammu and Kashmir', label: 'Jammu and Kashmir' },
  { value: 'Ladakh', label: 'Ladakh' },
  { value: 'Puducherry', label: 'Puducherry' },
  { value: 'Chandigarh', label: 'Chandigarh' },
  { value: 'Andaman and Nicobar Islands', label: 'Andaman and Nicobar Islands' },
  { value: 'Dadra and Nagar Haveli', label: 'Dadra and Nagar Haveli' },
  { value: 'Daman and Diu', label: 'Daman and Diu' },
  { value: 'Lakshadweep', label: 'Lakshadweep' },
];

// Yes/No Options for additional info
export const YES_NO_OPTIONS = [
  { value: '', label: 'Select Option' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: 'Occasionally', label: 'Occasionally' },
];

// ====================================================================================
// EDUCATION STRUCTURE - Comprehensive Multi-Entry Design
// ====================================================================================

// New Education Structure - Comprehensive Multi-Entry Design
export const EDUCATIONAL_QUALIFICATION_OPTIONS = [
  { value: 'High School', label: 'High School' },
  { value: 'Diploma', label: 'Diploma' },
  { value: 'Bachelor\'s Degree', label: 'Bachelor\'s Degree' },
  { value: 'B.E./B.Tech', label: 'B.E./B.Tech' },
  { value: 'B.Sc', label: 'B.Sc' },
  { value: 'B.Com', label: 'B.Com' },
  { value: 'B.A', label: 'B.A' },
  { value: 'BBA', label: 'BBA' },
  { value: 'BCA', label: 'BCA' },
  { value: 'Master\'s Degree', label: 'Master\'s Degree' },
  { value: 'M.E./M.Tech', label: 'M.E./M.Tech' },
  { value: 'M.Sc', label: 'M.Sc' },
  { value: 'M.Com', label: 'M.Com' },
  { value: 'M.A', label: 'M.A' },
  { value: 'MBA', label: 'MBA' },
  { value: 'MCA', label: 'MCA' },
  { value: 'MBBS', label: 'MBBS' },
  { value: 'MD', label: 'MD' },
  { value: 'MS (Medical)', label: 'MS (Medical)' },
  { value: 'BDS', label: 'BDS' },
  { value: 'MDS', label: 'MDS' },
  { value: 'B.Pharm', label: 'B.Pharm' },
  { value: 'M.Pharm', label: 'M.Pharm' },
  { value: 'LLB', label: 'LLB' },
  { value: 'LLM', label: 'LLM' },
  { value: 'PhD/Doctorate', label: 'PhD/Doctorate' },
  { value: 'CA', label: 'CA (Chartered Accountant)' },
  { value: 'CS', label: 'CS (Company Secretary)' },
  { value: 'CMA', label: 'CMA (Cost Management Accountant)' },
  { value: 'Other', label: 'Other' },
];

// Profession Options (Basic Preferences)
export const PROFESSION_OPTIONS = [
  { value: 'Software Engineer', label: 'Software Engineer' },
  { value: 'Doctor', label: 'Doctor' },
  { value: 'Nurse', label: 'Nurse' },
  { value: 'Teacher', label: 'Teacher' },
  { value: 'Professor', label: 'Professor' },
  { value: 'Engineer', label: 'Engineer' },
  { value: 'Accountant', label: 'Accountant' },
  { value: 'Banker', label: 'Banker' },
  { value: 'Business Owner', label: 'Business Owner' },
  { value: 'Entrepreneur', label: 'Entrepreneur' },
  { value: 'Government Employee', label: 'Government Employee' },
  { value: 'Civil Servant (IAS/IPS/IFS)', label: 'Civil Servant (IAS/IPS/IFS)' },
  { value: 'Lawyer', label: 'Lawyer' },
  { value: 'Architect', label: 'Architect' },
  { value: 'Designer', label: 'Designer' },
  { value: 'Marketing Professional', label: 'Marketing Professional' },
  { value: 'Sales Professional', label: 'Sales Professional' },
  { value: 'HR Professional', label: 'HR Professional' },
  { value: 'Consultant', label: 'Consultant' },
  { value: 'Chartered Accountant', label: 'Chartered Accountant' },
  { value: 'Pharmacist', label: 'Pharmacist' },
  { value: 'Pilot', label: 'Pilot' },
  { value: 'Defense Services', label: 'Defense Services' },
  { value: 'Police Officer', label: 'Police Officer' },
  { value: 'Artist', label: 'Artist' },
  { value: 'Actor/Actress', label: 'Actor/Actress' },
  { value: 'Musician', label: 'Musician' },
  { value: 'Writer', label: 'Writer' },
  { value: 'Journalist', label: 'Journalist' },
  { value: 'Research Scholar', label: 'Research Scholar' },
  { value: 'Student', label: 'Student' },
  { value: 'Not Working', label: 'Not Working' },
  { value: 'Homemaker', label: 'Homemaker' },
  { value: 'Other', label: 'Other' },
];

// Age Options (Physical & Age Preferences)
export const AGE_OPTIONS = [
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
  { value: '24', label: '24' },
  { value: '25', label: '25' },
  { value: '26', label: '26' },
  { value: '27', label: '27' },
  { value: '28', label: '28' },
  { value: '29', label: '29' },
  { value: '30', label: '30' },
  { value: '31', label: '31' },
  { value: '32', label: '32' },
  { value: '33', label: '33' },
  { value: '34', label: '34' },
  { value: '35', label: '35' },
  { value: '36', label: '36' },
  { value: '37', label: '37' },
  { value: '38', label: '38' },
  { value: '39', label: '39' },
  { value: '40', label: '40' },
  { value: '41', label: '41' },
  { value: '42', label: '42' },
  { value: '43', label: '43' },
  { value: '44', label: '44' },
  { value: '45', label: '45' },
  { value: '46', label: '46' },
  { value: '47', label: '47' },
  { value: '48', label: '48' },
  { value: '49', label: '49' },
  { value: '50', label: '50' },
  { value: '51', label: '51' },
  { value: '52', label: '52' },
  { value: '53', label: '53' },
  { value: '54', label: '54' },
  { value: '55', label: '55' },
  { value: '56', label: '56' },
  { value: '57', label: '57' },
  { value: '58', label: '58' },
  { value: '59', label: '59' },
  { value: '60', label: '60' },
  { value: '61', label: '61' },
  { value: '62', label: '62' },
  { value: '63', label: '63' },
  { value: '64', label: '64' },
  { value: '65', label: '65' },
  { value: '66', label: '66' },
  { value: '67', label: '67' },
  { value: '68', label: '68' },
  { value: '69', label: '69' },
  { value: '70', label: '70' },
];

// Caste/Kulam Options (Cultural Preferences)
export const CASTE_OPTIONS = [
  { value: 'Brahmin', label: 'Brahmin' },
  { value: 'Kshatriya', label: 'Kshatriya' },
  { value: 'Vaishya', label: 'Vaishya' },
  { value: 'Shudra', label: 'Shudra' },
  { value: 'Yadav', label: 'Yadav' },
  { value: 'Reddy', label: 'Reddy' },
  { value: 'Gowda', label: 'Gowda' },
  { value: 'Naidu', label: 'Naidu' },
  { value: 'Iyer', label: 'Iyer' },
  { value: 'Iyengar', label: 'Iyengar' },
  { value: 'Nair', label: 'Nair' },
  { value: 'Menon', label: 'Menon' },
  { value: 'Pillai', label: 'Pillai' },
  { value: 'Mudaliar', label: 'Mudaliar' },
  { value: 'Chettiar', label: 'Chettiar' },
  { value: 'Gounder', label: 'Gounder' },
  { value: 'Naicker', label: 'Naicker' },
  { value: 'Thevar', label: 'Thevar' },
  { value: 'Vanniyar', label: 'Vanniyar' },
  { value: 'Velama', label: 'Velama' },
  { value: 'Kamma', label: 'Kamma' },
  { value: 'Kapu', label: 'Kapu' },
  { value: 'Lingayat', label: 'Lingayat' },
  { value: 'Vokkaliga', label: 'Vokkaliga' },
  { value: 'Ezhava', label: 'Ezhava' },
  { value: 'Thiyya', label: 'Thiyya' },
  { value: 'Viswakarma', label: 'Viswakarma' },
  { value: 'Maratha', label: 'Maratha' },
  { value: 'Kunbi', label: 'Kunbi' },
  { value: 'Patel', label: 'Patel' },
  { value: 'Jat', label: 'Jat' },
  { value: 'Rajput', label: 'Rajput' },
  { value: 'Gurjar', label: 'Gurjar' },
  { value: 'Bania', label: 'Bania' },
  { value: 'Kayastha', label: 'Kayastha' },
  { value: 'Bhumihar', label: 'Bhumihar' },
  { value: 'Kurmi', label: 'Kurmi' },
  { value: 'Arora', label: 'Arora' },
  { value: 'Khatri', label: 'Khatri' },
  { value: 'Sikh Jat', label: 'Sikh Jat' },
  { value: 'Scheduled Caste (SC)', label: 'Scheduled Caste (SC)' },
  { value: 'Scheduled Tribe (ST)', label: 'Scheduled Tribe (ST)' },
  { value: 'OBC', label: 'OBC (Other Backward Class)' },
  { value: 'Caste No Bar', label: 'Caste No Bar' },
  { value: 'Other', label: 'Other' },
];

// Current Location Options (Location & Lifestyle)
export const CURRENT_LOCATION_OPTIONS = [
  // Indian Cities
  { value: 'Mumbai, India', label: 'Mumbai, India' },
  { value: 'Delhi, India', label: 'Delhi, India' },
  { value: 'Bangalore, India', label: 'Bangalore, India' },
  { value: 'Hyderabad, India', label: 'Hyderabad, India' },
  { value: 'Chennai, India', label: 'Chennai, India' },
  { value: 'Kolkata, India', label: 'Kolkata, India' },
  { value: 'Pune, India', label: 'Pune, India' },
  { value: 'Ahmedabad, India', label: 'Ahmedabad, India' },
  { value: 'Surat, India', label: 'Surat, India' },
  { value: 'Jaipur, India', label: 'Jaipur, India' },
  { value: 'Lucknow, India', label: 'Lucknow, India' },
  { value: 'Kanpur, India', label: 'Kanpur, India' },
  { value: 'Nagpur, India', label: 'Nagpur, India' },
  { value: 'Indore, India', label: 'Indore, India' },
  { value: 'Thane, India', label: 'Thane, India' },
  { value: 'Bhopal, India', label: 'Bhopal, India' },
  { value: 'Visakhapatnam, India', label: 'Visakhapatnam, India' },
  { value: 'Vadodara, India', label: 'Vadodara, India' },
  { value: 'Coimbatore, India', label: 'Coimbatore, India' },
  { value: 'Kochi, India', label: 'Kochi, India' },
  { value: 'Trivandrum, India', label: 'Trivandrum, India' },
  { value: 'Madurai, India', label: 'Madurai, India' },
  { value: 'Vijayawada, India', label: 'Vijayawada, India' },
  { value: 'Mysore, India', label: 'Mysore, India' },
  // International Cities
  { value: 'Dubai, UAE', label: 'Dubai, UAE' },
  { value: 'Abu Dhabi, UAE', label: 'Abu Dhabi, UAE' },
  { value: 'Riyadh, Saudi Arabia', label: 'Riyadh, Saudi Arabia' },
  { value: 'Jeddah, Saudi Arabia', label: 'Jeddah, Saudi Arabia' },
  { value: 'Doha, Qatar', label: 'Doha, Qatar' },
  { value: 'Kuwait City, Kuwait', label: 'Kuwait City, Kuwait' },
  { value: 'Muscat, Oman', label: 'Muscat, Oman' },
  { value: 'Manama, Bahrain', label: 'Manama, Bahrain' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'London, UK', label: 'London, UK' },
  { value: 'New York, USA', label: 'New York, USA' },
  { value: 'San Francisco, USA', label: 'San Francisco, USA' },
  { value: 'Los Angeles, USA', label: 'Los Angeles, USA' },
  { value: 'Chicago, USA', label: 'Chicago, USA' },
  { value: 'Toronto, Canada', label: 'Toronto, Canada' },
  { value: 'Vancouver, Canada', label: 'Vancouver, Canada' },
  { value: 'Sydney, Australia', label: 'Sydney, Australia' },
  { value: 'Melbourne, Australia', label: 'Melbourne, Australia' },
  { value: 'Auckland, New Zealand', label: 'Auckland, New Zealand' },
  { value: 'Other', label: 'Other' },
];

// ====================================================================================
// MORE INFORMATION TAB - Additional profile details
// ====================================================================================

// Hobbies & Interests Options
export const HOBBIES_OPTIONS = [
  { value: 'Reading', label: 'Reading' },
  { value: 'Writing', label: 'Writing' },
  { value: 'Painting', label: 'Painting' },
  { value: 'Drawing', label: 'Drawing' },
  { value: 'Photography', label: 'Photography' },
  { value: 'Cooking', label: 'Cooking' },
  { value: 'Baking', label: 'Baking' },
  { value: 'Gardening', label: 'Gardening' },
  { value: 'Traveling', label: 'Traveling' },
  { value: 'Dancing', label: 'Dancing' },
  { value: 'Singing', label: 'Singing' },
  { value: 'Playing Musical Instruments', label: 'Playing Musical Instruments' },
  { value: 'Watching Movies', label: 'Watching Movies' },
  { value: 'Listening to Music', label: 'Listening to Music' },
  { value: 'Gaming', label: 'Gaming' },
  { value: 'Sports', label: 'Sports' },
  { value: 'Yoga', label: 'Yoga' },
  { value: 'Meditation', label: 'Meditation' },
  { value: 'Fitness/Gym', label: 'Fitness/Gym' },
  { value: 'Cycling', label: 'Cycling' },
  { value: 'Swimming', label: 'Swimming' },
  { value: 'Trekking', label: 'Trekking' },
  { value: 'Hiking', label: 'Hiking' },
  { value: 'Volunteering', label: 'Volunteering' },
  { value: 'Blogging', label: 'Blogging' },
  { value: 'Vlogging', label: 'Vlogging' },
  { value: 'Crafts & DIY', label: 'Crafts & DIY' },
  { value: 'Fashion', label: 'Fashion' },
  { value: 'Shopping', label: 'Shopping' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Astrology', label: 'Astrology' },
  { value: 'Religion & Spirituality', label: 'Religion & Spirituality' },
  { value: 'Other', label: 'Other' },
];

// Sports Options
export const SPORTS_OPTIONS = [
  { value: 'Cricket', label: 'Cricket' },
  { value: 'Football', label: 'Football' },
  { value: 'Badminton', label: 'Badminton' },
  { value: 'Tennis', label: 'Tennis' },
  { value: 'Table Tennis', label: 'Table Tennis' },
  { value: 'Basketball', label: 'Basketball' },
  { value: 'Volleyball', label: 'Volleyball' },
  { value: 'Swimming', label: 'Swimming' },
  { value: 'Athletics', label: 'Athletics' },
  { value: 'Running', label: 'Running' },
  { value: 'Cycling', label: 'Cycling' },
  { value: 'Gym/Fitness', label: 'Gym/Fitness' },
  { value: 'Yoga', label: 'Yoga' },
  { value: 'Chess', label: 'Chess' },
  { value: 'Kabaddi', label: 'Kabaddi' },
  { value: 'Hockey', label: 'Hockey' },
  { value: 'Golf', label: 'Golf' },
  { value: 'Squash', label: 'Squash' },
  { value: 'Martial Arts', label: 'Martial Arts' },
  { value: 'Boxing', label: 'Boxing' },
  { value: 'Wrestling', label: 'Wrestling' },
  { value: 'Rock Climbing', label: 'Rock Climbing' },
  { value: 'Adventure Sports', label: 'Adventure Sports' },
  { value: 'Not Interested', label: 'Not Interested' },
  { value: 'Other', label: 'Other' },
];

// Favorite Movies Options
export const FAVORITE_MOVIES_OPTIONS = [
  { value: 'Action', label: 'Action' },
  { value: 'Comedy', label: 'Comedy' },
  { value: 'Drama', label: 'Drama' },
  { value: 'Romance', label: 'Romance' },
  { value: 'Thriller', label: 'Thriller' },
  { value: 'Horror', label: 'Horror' },
  { value: 'Science Fiction', label: 'Science Fiction' },
  { value: 'Fantasy', label: 'Fantasy' },
  { value: 'Animation', label: 'Animation' },
  { value: 'Documentary', label: 'Documentary' },
  { value: 'Bollywood', label: 'Bollywood' },
  { value: 'Hollywood', label: 'Hollywood' },
  { value: 'Tamil Cinema', label: 'Tamil Cinema' },
  { value: 'Telugu Cinema', label: 'Telugu Cinema' },
  { value: 'Malayalam Cinema', label: 'Malayalam Cinema' },
  { value: 'Kannada Cinema', label: 'Kannada Cinema' },
  { value: 'Bengali Cinema', label: 'Bengali Cinema' },
  { value: 'Marathi Cinema', label: 'Marathi Cinema' },
  { value: 'Regional Cinema', label: 'Regional Cinema' },
  { value: 'Classic Movies', label: 'Classic Movies' },
  { value: 'International Cinema', label: 'International Cinema' },
  { value: 'Not Interested', label: 'Not Interested' },
  { value: 'Other', label: 'Other' },
];

// Favorite Music Options
export const FAVORITE_MUSIC_OPTIONS = [
  { value: 'Bollywood', label: 'Bollywood' },
  { value: 'Tamil', label: 'Tamil' },
  { value: 'Telugu', label: 'Telugu' },
  { value: 'Malayalam', label: 'Malayalam' },
  { value: 'Kannada', label: 'Kannada' },
  { value: 'Classical', label: 'Classical (Carnatic/Hindustani)' },
  { value: 'Devotional', label: 'Devotional' },
  { value: 'Pop', label: 'Pop' },
  { value: 'Rock', label: 'Rock' },
  { value: 'Jazz', label: 'Jazz' },
  { value: 'Hip Hop', label: 'Hip Hop' },
  { value: 'Electronic/EDM', label: 'Electronic/EDM' },
  { value: 'Folk', label: 'Folk' },
  { value: 'Sufi', label: 'Sufi' },
  { value: 'Ghazals', label: 'Ghazals' },
  { value: 'Indie', label: 'Indie' },
  { value: 'Country', label: 'Country' },
  { value: 'Blues', label: 'Blues' },
  { value: 'Reggae', label: 'Reggae' },
  { value: 'R&B', label: 'R&B' },
  { value: 'Metal', label: 'Metal' },
  { value: 'Instrumental', label: 'Instrumental' },
  { value: 'All Genres', label: 'All Genres' },
  { value: 'Other', label: 'Other' },
];

// Spoken Languages Options
export const SPOKEN_LANGUAGES_OPTIONS = [
  { value: 'Tamil', label: 'Tamil' },
  { value: 'Telugu', label: 'Telugu' },
  { value: 'Kannada', label: 'Kannada' },
  { value: 'Malayalam', label: 'Malayalam' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'English', label: 'English' },
  { value: 'Marathi', label: 'Marathi' },
  { value: 'Gujarati', label: 'Gujarati' },
  { value: 'Bengali', label: 'Bengali' },
  { value: 'Punjabi', label: 'Punjabi' },
  { value: 'Urdu', label: 'Urdu' },
  { value: 'Odia', label: 'Odia' },
  { value: 'Assamese', label: 'Assamese' },
  { value: 'Sanskrit', label: 'Sanskrit' },
  { value: 'French', label: 'French' },
  { value: 'German', label: 'German' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'Mandarin', label: 'Mandarin' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Other', label: 'Other' },
];

// Smoking Options
export const SMOKING_OPTIONS = [
  { value: '', label: 'Select Option' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: 'Occasionally', label: 'Occasionally' },
];

// Drinking Options
export const DRINKING_OPTIONS = [
  { value: '', label: 'Select Option' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: 'Occasionally', label: 'Occasionally' },
];

// Special Interests Options
export const SPECIAL_INTERESTS_OPTIONS = [
  { value: 'Art & Culture', label: 'Art & Culture' },
  { value: 'Literature', label: 'Literature' },
  { value: 'History', label: 'History' },
  { value: 'Science & Technology', label: 'Science & Technology' },
  { value: 'Politics', label: 'Politics' },
  { value: 'Environment & Nature', label: 'Environment & Nature' },
  { value: 'Social Work', label: 'Social Work' },
  { value: 'Animal Welfare', label: 'Animal Welfare' },
  { value: 'Entrepreneurship', label: 'Entrepreneurship' },
  { value: 'Investment & Finance', label: 'Investment & Finance' },
  { value: 'Real Estate', label: 'Real Estate' },
  { value: 'Automobiles', label: 'Automobiles' },
  { value: 'Aviation', label: 'Aviation' },
  { value: 'Space & Astronomy', label: 'Space & Astronomy' },
  { value: 'Philosophy', label: 'Philosophy' },
  { value: 'Psychology', label: 'Psychology' },
  { value: 'Health & Wellness', label: 'Health & Wellness' },
  { value: 'Nutrition', label: 'Nutrition' },
  { value: 'Fashion & Beauty', label: 'Fashion & Beauty' },
  { value: 'Interior Design', label: 'Interior Design' },
  { value: 'Architecture', label: 'Architecture' },
  { value: 'Spirituality', label: 'Spirituality' },
  { value: 'Mythology', label: 'Mythology' },
  { value: 'Collecting (Coins/Stamps)', label: 'Collecting (Coins/Stamps)' },
  { value: 'Magic & Illusions', label: 'Magic & Illusions' },
  { value: 'Other', label: 'Other' },
];

// ====================================================================================
// EDUCATION STRUCTURE - Comprehensive Multi-Entry Design
// ====================================================================================

// New Education Structure - Comprehensive Multi-Entry Design
export const EDUCATION_TYPES = [
  { value: '', label: 'Select Education Type' },
  { value: 'professional', label: 'Professional Degree' },
  { value: 'postgraduate', label: 'Postgraduate Degree' },
  { value: 'undergraduate', label: 'Undergraduate Degree' },
  { value: 'diploma', label: 'Diploma & Certifications' },
  { value: 'school', label: 'School-Level & Others' },
  { value: 'no_education', label: 'No Education' },
  { value: 'other', label: 'Other' }
];

// Education Type Hierarchy for sorting (higher number = higher priority)
export const EDUCATION_HIERARCHY = {
  'professional': 7,
  'postgraduate': 6,
  'undergraduate': 5,
  'diploma': 4,
  'school': 3,
  'no_education': 1,
  'other': 2
};

export const EDUCATION_COURSES = {
  professional: [
    { value: '', label: 'Select Course' },
    { value: 'CA', label: 'CA - Chartered Accountant' },
    { value: 'CS', label: 'CS - Company Secretary' },
    { value: 'CFA', label: 'CFA - Chartered Financial Analyst' },
    { value: 'ICWA', label: 'ICWA - Cost & Management Accountant' },
    { value: 'IAS', label: 'IAS - Indian Administrative Service' },
    { value: 'IPS', label: 'IPS - Indian Police Service' },
    { value: 'IRS', label: 'IRS - Indian Revenue Service' },
    { value: 'IFS', label: 'IFS - Indian Foreign Service' },
    { value: 'Other', label: 'Other Professional Degree' }
  ],
  postgraduate: [
    { value: '', label: 'Select Course' },
    { value: 'MS', label: 'MS - Master of Science' },
    { value: 'MBA', label: 'MBA - Master of Business Administration' },
    { value: 'PGDM', label: 'PGDM - Post Graduate Diploma in Management' },
    { value: 'M.Tech', label: 'M.Tech - Master of Technology' },
    { value: 'ME', label: 'ME - Master of Engineering' },
    { value: 'MCA', label: 'MCA - Master of Computer Applications' },
    { value: 'M.Ed', label: 'M.Ed - Master of Education' },
    { value: 'M.Sc', label: 'M.Sc - Master of Science' },
    { value: 'M.Com', label: 'M.Com - Master of Commerce' },
    { value: 'MA', label: 'MA - Master of Arts' },
    { value: 'MSW', label: 'MSW - Master of Social Work' },
    { value: 'M.Arch', label: 'M.Arch - Master of Architecture' },
    { value: 'MDS', label: 'MDS - Master of Dental Surgery' },
    { value: 'MPT', label: 'MPT - Master of Physiotherapy' },
    { value: 'M.Pharm', label: 'M.Pharm - Master of Pharmacy' },
    { value: 'Ph.D', label: 'Ph.D - Doctor of Philosophy' },
    { value: 'M.Phil', label: 'M.Phil - Master of Philosophy' },
    { value: 'Other', label: 'Other Postgraduate Degree' }
  ],
  undergraduate: [
    { value: '', label: 'Select Course' },
    { value: 'B.Tech', label: 'B.Tech - Bachelor of Technology' },
    { value: 'BE', label: 'BE - Bachelor of Engineering' },
    { value: 'BCA', label: 'BCA - Bachelor of Computer Applications' },
    { value: 'BBA', label: 'BBA - Bachelor of Business Administration' },
    { value: 'B.Com', label: 'B.Com - Bachelor of Commerce' },
    { value: 'B.Sc', label: 'B.Sc - Bachelor of Science' },
    { value: 'BA', label: 'BA - Bachelor of Arts' },
    { value: 'MBBS', label: 'MBBS - Bachelor of Medicine & Surgery' },
    { value: 'BDS', label: 'BDS - Bachelor of Dental Surgery' },
    { value: 'BPT', label: 'BPT - Bachelor of Physiotherapy' },
    { value: 'B.Pharm', label: 'B.Pharm - Bachelor of Pharmacy' },
    { value: 'B.Arch', label: 'B.Arch - Bachelor of Architecture' },
    { value: 'BL/LLB', label: 'BL/LLB - Bachelor of Law' },
    { value: 'Other', label: 'Other Undergraduate Degree' }
  ],
  diploma: [
    { value: '', label: 'Select Course' },
    { value: 'Diploma in Engineering', label: 'Diploma in Engineering' },
    { value: 'Diploma in Computer Science', label: 'Diploma in Computer Science' },
    { value: 'Diploma in Management', label: 'Diploma in Management' },
    { value: 'PG Diploma', label: 'Post Graduate Diploma' },
    { value: 'Pilot License', label: 'Pilot License' },
    { value: 'PGDCA', label: 'PGDCA - Post Graduate Diploma in Computer Applications' },
    { value: 'OCP', label: 'OCP - Oracle Certified Professional' },
    { value: 'ACA', label: 'ACA - Associate Chartered Accountant' },
    { value: 'Other', label: 'Other Diploma/Certification' }
  ],
  school: [
    { value: '', label: 'Select Course' },
    { value: '12th', label: 'Class 12th/HSC/Intermediate' },
    { value: '10th', label: 'Class 10th/SSC/Matriculation' },
    { value: 'Other', label: 'Other School Level Education' }
  ],
  no_education: [
    { value: 'No Formal Education', label: 'No Formal Education' }
  ],
  other: [
    { value: '', label: 'Select Course' },
    { value: 'Other', label: 'Other Educational Qualification' }
  ]
};

export const EDUCATION_SPECIALIZATIONS = {
  // Professional specializations
  CA: [
    { value: '', label: 'Select Specialization' },
    { value: 'Audit', label: 'Audit & Assurance' },
    { value: 'Taxation', label: 'Taxation' },
    { value: 'Corporate Finance', label: 'Corporate Finance' },
    { value: 'Other', label: 'Other' }
  ],
  MBA: [
    { value: '', label: 'Select Specialization' },
    { value: 'Finance', label: 'Finance' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'HR', label: 'Human Resources' },
    { value: 'Ops Management', label: 'Operations Management' },
    { value: 'IT', label: 'Information Technology' },
    { value: 'Int. Business', label: 'International Business' },
    { value: 'Entrepreneurship', label: 'Entrepreneurship' },
    { value: 'Other', label: 'Other' }
  ],
  MS: [
    { value: '', label: 'Select Specialization' },
    { value: 'CSC', label: 'Computer Science' },
    { value: 'EEE', label: 'Electrical Engineering' },
    { value: 'Mech', label: 'Mechanical Engineering' },
    { value: 'Civil', label: 'Civil Engineering' },
    { value: 'Cyber Security', label: 'Cyber Security' },
    { value: 'Data Science', label: 'Data Science' },
    { value: 'AI/ML', label: 'Artificial Intelligence/ Machine Learning' },
    { value: 'BA/BI', label: 'Business Analytics/Information Systems' },
    { value: 'Bio Medical', label: 'Biomedical/Bioengineering' },
    { value: 'Other', label: 'Other' }
  ],
  "M.Tech": [
    { value: '', label: 'Select Specialization' },
    { value: 'CSE', label: 'Computer Science & Engineering' },
    { value: 'Mech', label: 'Mechanical Engineering' },
    { value: 'EEE', label: 'Electrical Engineering' },
    { value: 'Civil', label: 'Civil Engineering' },
    { value: 'ECE', label: 'Electronics & Communication' },
    { value: 'Chemical', label: 'Chemical Engineering' },
    { value: 'Other', label: 'Other' }
  ],
  "B.Tech": [
    { value: '', label: 'Select Specialization' },
    { value: 'CSE', label: 'Computer Science & Engineering' },
    { value: 'IT', label: 'Information Technology' },
    { value: 'Mech', label: 'Mechanical Engineering' },
    { value: 'EEE', label: 'Electrical Engineering' },
    { value: 'Civil', label: 'Civil Engineering' },
    { value: 'ECE', label: 'Electronics & Communication' },
    { value: 'Chemical', label: 'Chemical Engineering' },
    { value: 'Aerospace', label: 'Aerospace Engineering' },
    { value: 'Biotechnology', label: 'Biotechnology' },
    { value: 'Other', label: 'Other' }
  ],
  "B.Com": [
    { value: '', label: 'Select Specialization' },
    { value: 'Accounting', label: 'Accounting & Finance' },
    { value: 'Banking', label: 'Banking & Insurance' },
    { value: 'Tax', label: 'Taxation' },
    { value: 'Gen', label: 'General Commerce' },
    { value: 'Other', label: 'Other' }
  ],
  "B.Sc": [
    { value: '', label: 'Select Specialization' },
    { value: 'Physics', label: 'Physics' },
    { value: 'Chemistry', label: 'Chemistry' },
    { value: 'Mathematics', label: 'Mathematics' },
    { value: 'Biology', label: 'Biology/Life Sciences' },
    { value: 'Computers', label: 'Computer Science' },
    { value: 'Statistics', label: 'Statistics' },
    { value: 'Other', label: 'Other' }
  ],
  BA: [
    { value: '', label: 'Select Specialization' },
    { value: 'English', label: 'English Literature' },
    { value: 'History', label: 'History' },
    { value: 'Politics', label: 'Political Science' },
    { value: 'Economics', label: 'Economics' },
    { value: 'Psychology', label: 'Psychology' },
    { value: 'Sociology', label: 'Sociology' },
    { value: 'Other', label: 'Other' }
  ],
  '12th': [
    { value: '', label: 'Select Stream' },
    { value: 'Science - PCM', label: 'Science (PCM - Physics, Chemistry, Maths)' },
    { value: 'Science - PCB', label: 'Science (PCB - Physics, Chemistry, Biology)' },
    { value: 'Commerce', label: 'Commerce' },
    { value: 'Arts', label: 'Arts/Humanities' },
    { value: 'Other', label: 'Other' }
  ],
  '10th': [
    { value: 'General', label: 'General Studies' }
  ],
  // Add 'other' option for all courses that don't have specific specializations
  other: [
    { value: 'Other', label: 'Please specify in additional details' }
  ]
};

// Legacy constants for backward compatibility
export const EDUCATION_LEVELS = [
  { value: '', label: 'Select Education' },
  // School Education
  { value: '10th', label: 'Class 10th/SSC/Matriculation', shortLabel: '10th' },
  { value: '12th', label: 'Class 12th/HSC/Intermediate', shortLabel: '12th' },
  // Diploma
  { value: 'diploma_engineering', label: 'Diploma in Engineering', shortLabel: 'Diploma Engineering' },
  { value: 'diploma_computer', label: 'Diploma in Computer Science', shortLabel: 'Diploma CS' },
  { value: 'diploma_management', label: 'Diploma in Management', shortLabel: 'Diploma Management' },
  { value: 'pg_diploma', label: 'Post Graduate Diploma', shortLabel: 'PG Diploma' },
  { value: 'pilot_license', label: 'Pilot License' },
  { value: 'pgdca', label: 'PGDCA - Post Graduate Diploma in Computer Applications', shortLabel: 'PGDCA' },
  { value: 'ocp', label: 'OCP - Oracle Certified Professional', shortLabel: 'OCP' },
  { value: 'aca', label: 'ACA - Associate Chartered Accountant', shortLabel: 'ACA' },
  // Undergraduate
  { value: 'btech', label: 'B.Tech - Bachelor of Technology', shortLabel: 'B.Tech' },
  { value: 'be', label: 'BE - Bachelor of Engineering', shortLabel: 'BE' },
  { value: 'bca', label: 'BCA - Bachelor of Computer Applications', shortLabel: 'BCA' },
  { value: 'bba', label: 'BBA - Bachelor of Business Administration', shortLabel: 'BBA' },
  { value: 'bcom', label: 'B.Com - Bachelor of Commerce', shortLabel: 'B.Com' },
  { value: 'bsc', label: 'B.Sc - Bachelor of Science', shortLabel: 'B.Sc' },
  { value: 'ba', label: 'BA - Bachelor of Arts', shortLabel: 'BA' },
  { value: 'mbbs', label: 'MBBS - Bachelor of Medicine & Surgery', shortLabel: 'MBBS' },
  { value: 'bds', label: 'BDS - Bachelor of Dental Surgery', shortLabel: 'BDS' },
  { value: 'bpt', label: 'BPT - Bachelor of Physiotherapy', shortLabel: 'BPT' },
  { value: 'bpharm', label: 'B.Pharm - Bachelor of Pharmacy', shortLabel: 'B.Pharm' },
  { value: 'barch', label: 'B.Arch - Bachelor of Architecture', shortLabel: 'B.Arch' },
  { value: 'llb', label: 'BL/LLB - Bachelor of Law', shortLabel: 'LLB' },
  // Postgraduate
  { value: 'ms', label: 'MS - Master of Science', shortLabel: 'MS' },
  { value: 'mba', label: 'MBA - Master of Business Administration', shortLabel: 'MBA' },
  { value: 'pgdm', label: 'PGDM - Post Graduate Diploma in Management', shortLabel: 'PGDM' },
  { value: 'mtech', label: 'M.Tech - Master of Technology', shortLabel: 'M.Tech' },
  { value: 'me', label: 'ME - Master of Engineering', shortLabel: 'ME' },
  { value: 'mca', label: 'MCA - Master of Computer Applications', shortLabel: 'MCA' },
  { value: 'med', label: 'M.Ed - Master of Education', shortLabel: 'M.Ed' },
  { value: 'msc', label: 'M.Sc - Master of Science', shortLabel: 'M.Sc' },
  { value: 'mcom', label: 'M.Com - Master of Commerce', shortLabel: 'M.Com' },
  { value: 'ma', label: 'MA - Master of Arts', shortLabel: 'MA' },
  { value: 'msw', label: 'MSW - Master of Social Work', shortLabel: 'MSW' },
  { value: 'march', label: 'M.Arch - Master of Architecture', shortLabel: 'M.Arch' },
  { value: 'mds', label: 'MDS - Master of Dental Surgery', shortLabel: 'MDS' },
  { value: 'mpt', label: 'MPT - Master of Physiotherapy', shortLabel: 'MPT' },
  { value: 'mpharm', label: 'M.Pharm - Master of Pharmacy', shortLabel: 'M.Pharm' },
  { value: 'phd', label: 'Ph.D - Doctor of Philosophy', shortLabel: 'Ph.D' },
  { value: 'mphil', label: 'M.Phil - Master of Philosophy', shortLabel: 'M.Phil' },
  // Professional
  { value: 'ca', label: 'CA - Chartered Accountant', shortLabel: 'CA' },
  { value: 'cs', label: 'CS - Company Secretary', shortLabel: 'CS' },
  { value: 'cfa', label: 'CFA - Chartered Financial Analyst', shortLabel: 'CFA' },
  { value: 'icwa', label: 'ICWA - Cost & Management Accountant', shortLabel: 'ICWA' },
  { value: 'ias', label: 'IAS - Indian Administrative Service', shortLabel: 'IAS' },
  { value: 'ips', label: 'IPS - Indian Police Service', shortLabel: 'IPS' },
  { value: 'irs', label: 'IRS - Indian Revenue Service', shortLabel: 'IRS' },
  { value: 'ifs', label: 'IFS - Indian Foreign Service', shortLabel: 'IFS' },

  // Other
  { value: 'other', label: 'Other' },
  { value: 'no_formal_education', label: 'No Education' },
  { value: 'Any', label: 'Any' },
];

export const EDUCATION_STATUS_OPTIONS = [
  { value: '', label: 'Select Status' },
  { value: 'completed', label: 'Completed' },
  { value: 'pursuing', label: 'Currently Pursuing' },
  { value: 'discontinued', label: 'Discontinued' },
];

// Partner Preferences Options (Aliases for existing options)
export const PARTNER_EDUCATION_OPTIONS = EDUCATION_LEVELS;
export const PARTNER_MARITAL_STATUS_OPTIONS = MARITAL_STATUS_OPTIONS;
export const PARTNER_HEIGHT_OPTIONS = HEIGHT_OPTIONS;
